export default "__VITE_ASSET__5fabea0a__"